
const digest = '0c6b9cf74c2a8858d6d04b76f1f98a6bd34e6e164d5fe4f06e237d2680f1929f';
const css = `._inputItem_18w4i_1 {
	padding: 5px;
	background: #ccc;
	margin-right: 5px;
}
._deleteButton_18w4i_11 {
	cursor: pointer;
}
`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"inputItem":"_inputItem_18w4i_1","deleteButton":"_deleteButton_18w4i_11"};
export { css, digest };
  